export default "__VITE_ASSET__L1Xc5_fw__"